/* eslint-disable @typescript-eslint/no-explicit-any */
import cloneDeep from "lodash/cloneDeep";
import flowioast from "./flowioast";

export function GetControllerNameByDbContext(dbContext: string | number) {
  switch (dbContext) {
    case "Data":
      return "Database";
    case "App":
      return "Administration";
    case "Presentation":
      return "DataPresentation";
    default:
      // Aby se uživatel nedostal k erroru, ale přidal se do stacku
      flowioast.error("sj92s4qw8fr2", [
        [new Error("GetConrollerNameByDbContext: invalid db context")],
      ]);
  }
}

export function DeepCopy(obj: any) {
  return cloneDeep(obj);
}

export function IsEmaLiteAndroid() {
  return (document as any).emaLiteAndroid === true;
}

export function removeLeadingSlash(url: string | undefined) {
  if (url?.startsWith("/")) {
    return url.slice(1);
  }
  return url;
}

export const getBasenameFromHtml = () =>
  document.getElementsByTagName("base")[0].getAttribute("href") ?? undefined;
